import React, { useState, useEffect } from "react";
import {BASE_URL} from "../apiConfig";

const Test = () => {
    const [testapiData, setTestapiData] = useState([]); // ✅ useState is at top level

    const test = async () => {
        try {
            const response = await fetch(`${BASE_URL}/api/test/test`, {
                method: "GET",
                headers: { "Content-Type": "application/json" },
            });

            if (response.ok) {
                const data = await response.json();
                setTestapiData(data); // ✅ Correctly updating state
            } else {
                console.error("Failed to fetch API data");
            }
        } catch (error) {
            console.error("Error fetching API data:", error);
        }
    };

    useEffect(() => {
        test();
    }, []); // ✅ useEffect does not directly use an async function

    return (
        <div>
            <h1>Test API Data:</h1>
            <pre>{JSON.stringify(testapiData, null, 2)}</pre> {/* ✅ Properly render JSON */}
        </div>
    );
};

export default Test;
